import React from "react";
import { CTAButton } from "./CTAButton";
import { Reveal } from "./Reveal";
import { VideoPlayer } from "./VideoPlayer";
export { VIDEO_URL } from "./VideoPlayer";

/** Desktop only — on mobile the video lives inside the hero. */
export function VideoSection() {
  return <section aria-labelledby="video-quote" className="section-pad hidden border-b border-line md:block" data-id="element-377" data-mp="1iseerqoelvvw">
      <div className="page-container" data-id="element-378" data-mp="1wrw7gh4tltaj">
        <Reveal data-id="element-379" data-mp="1wquug748uwq6">
          <p className="eyebrow" data-id="element-380" data-mp="1wqcrysqznm9t">Mensaje del equipo · 90 segundos</p>
          <h2 id="video-quote" className="h2-section mt-4 !max-w-[28ch]" data-id="element-381" data-mp="1rs1i4i0p1brl">
            “Muchos negocios no necesitan más leads.{" "}
            <span className="text-gold" data-id="element-382" data-mp="26h7bvqgri9s3">Necesitan dejar de perder los que ya están pagando.</span>”
          </h2>
        </Reveal>
        <Reveal delay={0.08} className="mt-12" data-id="element-383" data-mp="2finevd58z9ma">
          <VideoPlayer mode="embed" data-id="element-384" data-mp="2fjgoqmzi6f8n" />
        </Reveal>
        <Reveal className="mt-10" data-id="element-385" data-mp="2bhbvhpcyvkmj">
          <CTAButton source="video" data-id="element-386" data-mp="2bi3k2g85ci3b" />
        </Reveal>
      </div>
    </section>;
}